import React, { Component } from "react";
import { Icon } from "semantic-ui-react";
import { Tooltip } from "react-tippy";
import { isLoggedInUser, isPostOpen } from "../../../../../../../../util/selectors";
import { showUserSignInModal } from "../../../../../../../../actions";
import { openAddToCollectionModal } from "../../../../../../../../actions/collectionActions";
import { likePost, unlikePost } from "../../../../../../../../actions/postActions";
import { connect } from "react-redux";
import SharingDropdown from "../../../../../../../SharingDropdown";
import mixpanel from "../../../../../../../../services/mixpanel";
import { getPostUrl } from "../../../../../../../../util";

import "./index.css";

class InteractionsBar extends Component {
  constructor(props) {
    super(props);

    this.likePost = this.likePost.bind(this);
    this.focusCommentInput = this.focusCommentInput.bind(this);
    this.handleCommentButtonClick = this.handleCommentButtonClick.bind(this);
    this.openAddToCollectionModal = this.openAddToCollectionModal.bind(this);
    const possibleTooltipsText = [
      "Like this case? Tell your friends about it!",
      "Share your favourite cases with your colleagues.",
      "Great work, right? Show it to the world!",
      "Like it? Share it!",
    ];
    //choose a random tooltip each time
    const chooseTooltipText = possibleTooltipsText[Math.floor(possibleTooltipsText.length * Math.random())];
    this.state = {
      isShareTooltipVisible: false,
      chooseTooltipText,
    };
  }

  likePost() {
    if (!this.props.isAuthorized) {
      sessionStorage.setItem("storeLastRoute", this.props.currRoutePath);
      return this.props.actions.showUserSignInModal();
    }
    if (this.props.post.isLiked) {
      return this.props.actions.unlikePost(this.props.post._id);
    }
    //only show share tool tip for the first liked post
    if (this.props.userLikes < 3) {
      this.setState(prevState => ({ ...prevState, isShareTooltipVisible: true }));
      mixpanel.track("show.tooltip", { text: this.state.chooseTooltipText });

      setTimeout(() => {
        this.setState(prevState => ({ ...prevState, isShareTooltipVisible: false }));
      }, 3000);
    }
    return this.props.actions.likePost(this.props.post._id);
  }

  focusCommentInput() {
    this.props.desktopCommentInputRef.focus();
    this.props.mobileCommentInputRef.focus();
  }

  handleCommentButtonClick() {
    if (this.props.isPostOpen) {
      return this.focusCommentInput();
    }
    this.props.viewPost();
  }

  openAddToCollectionModal() {
    this.props.actions.openAddToCollectionModal(this.props.post._id);
    mixpanel.track("post.save", { postId: this.props.post._id });
  }

  render() {
    const post = this.props.post;
    const sharingButton = (
      <button className="-button">
        <Icon name="share alternate" />
        <span>Share</span>
      </button>
    );
    return (
      <div className="-interactions-bar-wrapper">
        <button onClick={this.likePost} className={`-button ${post.isLiked ? "-active" : ""}`}>
          <Icon name={`thumbs up${post.isLiked ? "" : " outline"}`} />
          <span>{post.isLiked ? "Unlike" : "Like"}</span>
        </button>
        <button className="-button" onClick={this.handleCommentButtonClick}>
          <Icon name="comment outline" />
          <span>Comment</span>
        </button>
        <Tooltip
          open={this.state.isShareTooltipVisible}
          position="top"
          arrow="true"
          title={this.state.chooseTooltipText}
        >
          <SharingDropdown trigger={sharingButton} url={getPostUrl(post)} campaignName="case" eventSource="post" />
        </Tooltip>
        <button className="-button" onClick={this.openAddToCollectionModal}>
          <Icon name="bookmark outline" />
          <span>Save</span>
        </button>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isAuthorized: isLoggedInUser(state),
  currRoutePath: state.router.pathname,
  isPostOpen: isPostOpen(state),
  userLikes: state.user.stats.likesCount,
});

const mapDispatchToProps = dispatch => ({
  actions: {
    likePost: postId => dispatch(likePost(postId)),
    unlikePost: postId => dispatch(unlikePost(postId)),
    showUserSignInModal: () => dispatch(showUserSignInModal()),
    openAddToCollectionModal: postId => dispatch(openAddToCollectionModal(postId)),
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(InteractionsBar);



// WEBPACK FOOTER //
// ./src/components/PostsList/components/Interactions/components/InteractionsGroup/components/InteractionsBar/index.js